// extracted by mini-css-extract-plugin
export var bottomLinksColumn = "MainLayout-module--bottomLinksColumn--8be70";
export var bottomLinksRow = "MainLayout-module--bottomLinksRow--94d0e";
export var bottomLinksSection = "MainLayout-module--bottomLinksSection--0e48d";
export var bottomLinksTitle = "MainLayout-module--bottomLinksTitle--9e135";
export var bottomMarginInner = "MainLayout-module--bottomMarginInner--9c369";
export var bottomNav = "MainLayout-module--bottomNav--65d07";
export var bottomNavItemsContainer = "MainLayout-module--bottomNavItemsContainer--dd9da";
export var bottomSocialNetworkMenu = "MainLayout-module--bottomSocialNetworkMenu--3c5bf";
export var footer = "MainLayout-module--footer--82ec3";
export var icon = "MainLayout-module--icon--664b5";
export var iconRow = "MainLayout-module--iconRow--2f20a";
export var navItem = "MainLayout-module--navItem--e3645";
export var pageContent = "MainLayout-module--pageContent--ea094";
export var topMargin = "MainLayout-module--topMargin--dbfc1";